import { apiService } from 'services';
import { AxiosError } from 'axios';

export interface IEmailAddressResponse {
    maskedEmail: string;
    uniqueId: string;
}

export interface IEmailSendRequest {
    uniqueId: string;
    language?: string;
}

export interface IEmailSolveRequest {
    code: string;
}

export interface IVerificationResponse {
    responseResult: string;
    responseMessage?: string;
}

export const getEmailAddress = (
    callback: (response: IEmailAddressResponse) => void,
    errorCallback: (error: AxiosError) => void
): void => {
    apiService.get<IEmailAddressResponse>('/email/address', callback, errorCallback);
};

export const sendEmail = (
    body: IEmailSendRequest,
    callback: (response: IVerificationResponse) => void,
    errorCallback: (error: AxiosError) => void
): void => {
    apiService.post<IVerificationResponse>('/email/send', body, callback, errorCallback);
};

export const solveEmail = (
    body: IEmailSolveRequest,
    callback: (response: IVerificationResponse) => void,
    errorCallback: (error: AxiosError) => void
): void => {
    apiService.post<IVerificationResponse>('/email/solve', body, callback, errorCallback);
};
